import React from 'react';
import { Customer } from '../types/types';
import { MapPinIcon, ClockIcon, CalendarIcon } from 'lucide-react';
interface CustomerListProps {
  customers: Customer[];
  toggleCustomerSelection: (id: string) => void;
}
const CustomerList: React.FC<CustomerListProps> = ({
  customers,
  toggleCustomerSelection
}) => {
  if (customers.length === 0) {
    return <div className="text-center py-8 text-gray-500" data-id="element-35">
        No customers added yet
      </div>;
  }
  return <div className="space-y-3 max-h-[400px] overflow-y-auto pr-2" data-id="element-36">
      {customers.map(customer => <div key={customer.id} className={`border rounded-lg p-3 ${customer.selected ? 'border-blue-400 bg-blue-50' : 'border-gray-200 bg-white'}`} data-id="element-37">
          <div className="flex items-start justify-between" data-id="element-38">
            <div className="flex-1" data-id="element-39">
              <h3 className="font-medium text-gray-800" data-id="element-40">{customer.name}</h3>
              <div className="flex items-center text-sm text-gray-600 mt-1" data-id="element-41">
                <MapPinIcon className="w-4 h-4 mr-1 flex-shrink-0" data-id="element-42" />
                <span className="truncate" data-id="element-43">{customer.address}</span>
              </div>
              <div className="flex items-center text-sm text-gray-600 mt-1" data-id="element-44">
                <ClockIcon className="w-4 h-4 mr-1 flex-shrink-0" data-id="element-45" />
                <span data-id="element-46">{customer.timeOnSite} minutes on site</span>
              </div>
              <div className="flex items-center text-sm text-gray-600 mt-1" data-id="element-47">
                <CalendarIcon className="w-4 h-4 mr-1 flex-shrink-0" data-id="element-48" />
                <span className="truncate" data-id="element-49">
                  Available:{' '}
                  {customer.availableDays.map(day => day.substring(0, 3)).join(', ')}
                </span>
              </div>
            </div>
            <div className="ml-3" data-id="element-50">
              <input type="checkbox" checked={customer.selected} onChange={() => toggleCustomerSelection(customer.id)} className="h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500" data-id="element-51" />
            </div>
          </div>
        </div>)}
    </div>;
};
export default CustomerList;